<template>
  <div class="shedMonitor" ref="shedMonitor">
    <div class="tltle">
      <div class="home_number">15</div>
      <el-select v-model="value" filterable placeholder="请选择">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div class="monitor"></div>
    <div class="PM-chart" ref="chart"></div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import getOpt from "./js/chartOpt.js";
import { unwarp } from "@/utils/tools.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: ["matrix", "x", "y"],
  data() {
    //这里存放数据
    return {
      customerId: this.$store.state.customerId,
      chart: null,
      unit: 1,
      options: [
        {
          value: "选项1",
          label: "1#烧结",
        },
        {
          value: "选项2",
          label: "2#烧结",
        },
        {
          value: "选项3",
          label: "3#烧结",
        },
        {
          value: "选项4",
          label: "4#烧结",
        },
        {
          value: "选项5",
          label: "5#烧结",
        },
        {
          value: "选项5",
          label: "5#烧结",
        },
        {
          value: "选项5",
          label: "5#烧结",
        },
        {
          value: "选项5",
          label: "5#烧结",
        },
        {
          value: "选项5",
          label: "5#烧结",
        },
      ],
      value: "",
    };
  },
  //计算属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this;
    let w = $(that.$refs.shedMonitor).outerWidth();
    let h = $(that.$refs.shedMonitor).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    this.getData();
  },
  unmounted() {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  //方法集合
  methods: {
    async getData() {
      let _this = this;
      this.pmData = {
        xData: [],
        y1Data: [],
        y2Data: [],
      };
      let data = await _this.$apiUtils.get(
        "/newscreen/env/getAllHistoryByType",
        {
          customerId: _this.customerId,
          unit: _this.unit,
        }
      );
      data.forEach((x, index) => {
        let { x_data, day_time, pm10_avg_value, pm25_avg_value } = x;
        if (day_time.indexOf(" ") != -1) {
          day_time = day_time.split(" ")[1];
        }
        if (pm10_avg_value || pm25_avg_value) {
          this.noData = false;
        }
        this.pmData.xData.push(day_time);
        this.pmData.y1Data.push(pm10_avg_value);
        this.pmData.y2Data.push(pm25_avg_value);
      });
      this.$nextTick(() => {
        if (!this.chart) {
          this.chart = echarts.init(this.$refs.chart);
        }
        let optionStr = getOpt(this.pmData);
        unwarp(this.chart).setOption(optionStr);
      });
    },
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped='scoped'>
.shedMonitor {
  width: 600px;
  height: 520px;
  .tltle {
    display: flex;
    height: 24px;
    justify-content: flex-end;
    .home_number {
      margin-right: 166px;
    }
  }
  .monitor {
    @include bg-box(560px, 230px, "1.png");
    margin: 29px auto 15px;
  }
  .PM-chart {
    width: 100%;
    height: 150px;
    position: relative;
    margin: 0 auto;
  }
}
</style>